import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "fixed h-full pr-2",
  style: {"width":"inherit","z-index":"100"}
}
const _hoisted_2 = {
  key: 0,
  class: "mx-5 mt-6 overflow-hidden"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 1,
  class: "mx-5 mt-6 overflow-hidden"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "flex items-center space-x-2.5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("title", null, "robot-outline", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "M17.5 15.5C17.5 16.61 16.61 17.5 15.5 17.5S13.5 16.61 13.5 15.5 14.4 13.5 15.5 13.5 17.5 14.4 17.5 15.5M8.5 13.5C7.4 13.5 6.5 14.4 6.5 15.5S7.4 17.5 8.5 17.5 10.5 16.61 10.5 15.5 9.61 13.5 8.5 13.5M23 15V18C23 18.55 22.55 19 22 19H21V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 10.13 6.13 7 10 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M21 16H19V14C19 11.24 16.76 9 14 9H10C7.24 9 5 11.24 5 14V16H3V17H5V20H19V17H21V16Z" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "mt-6 ml-2 overflow-visible"
}
const _hoisted_11 = { class: "w-full h-full px-2" }
const _hoisted_12 = { class: "mobile-sidebar-header mt-4 rounded" }
const _hoisted_13 = { class: "mx-auto flex space-x-2 items-center" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "text-sm mb-0" }
const _hoisted_16 = {
  key: 0,
  class: "mt-3 ml-1.5 overflow-hidden"
}
const _hoisted_17 = { class: "flex flex-col w-full mt-6 -ml-4" }
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "flex items-center space-x-2.5" }
const _hoisted_20 = { class: "ml-4 md:inline" }
const _hoisted_21 = {
  key: 1,
  class: "mt-6 ml-2 overflow-visible"
}
const _hoisted_22 = { class: "flex w-full mt-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined mr-2" }, " logout ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle(
			'' +
			(_ctx.hovering && !!_ctx.collapsed
				? 'box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.3); z-index: 50'
				: '')
		),
      class: _normalizeClass(["flex-col hidden h-full md:block bg-light", {
			'absolute top-0': true || !!_ctx.collapsed,
			'w-18': !_ctx.hovering && !!_ctx.collapsed,
			'lg:w-2/12 w-4/12 hovering-sidebar': _ctx.hovering || !_ctx.collapsed,
			'transition-width duration-200 ease-in-out': !_ctx.initializing,
		}]),
      id: "desktop-nav"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "h-full",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSideBarHover($event))),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSideBarLeave()))
        }, [
          (_ctx.header)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h5", {
                  title: _ctx.header,
                  style: {"text-overflow":"ellipsis","white-space":"nowrap","max-width":"500px"},
                  class: "mb-0 overflow-hidden"
                }, _toDisplayString(_ctx.header), 9, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.header?.())
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "header")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", {
            class: _normalizeClass(["flex flex-col w-full mt-6", { 'h-full': !_ctx.$slots.footer?.() }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarOptions, (option, index) => {
              return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                class: _normalizeClass(["relative overflow-hidden rounded-r-full", {
							'mt-auto mb-44': false && index == _ctx.sidebarOptions.length - 1,
							'pl-1.25px': true || (!_ctx.hovering && !!_ctx.collapsed),
						}]),
                key: 'sidebar-' + option.label,
                to: { name: option.routeName }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    id: 'sidebar-option-' + index,
                    style: {"padding-top":"11px","padding-bottom":"11px"},
                    class: _normalizeClass(["flex items-center justify-between px-4 cursor-pointer sidebar-link-container hover:transition-colors text-darkText hover:bg-primary-light hover:bg-opacity-10 hover:duration-100", {
								'md:w-full': true || !!_ctx.collapsed,
								'md:w-11/12': false && !_ctx.collapsed,
								'rounded-r-full pl-5 -ml-1.25px': _ctx.hovering || !_ctx.collapsed,
								'rounded-full ml-1': !_ctx.hovering && !!_ctx.collapsed,
								'bg-primary-light bg-opacity-20 pointer-events-none':
									_ctx.isRouteActive(option),
							}])
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      (option.icon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([
										'text-2xl  material-icons-outlined',
										_ctx.isRouteActive(option) ? 'text-primary' : 'opacity-60 text-darkText',
									])
                          }, _toDisplayString(option.icon), 3))
                        : (_openBlock(), _createElementBlock("svg", {
                            key: 1,
                            style: {"width":"24px","padding-right":"1px","padding-top":"3px","padding-bottom":"4px"},
                            class: _normalizeClass([
										_ctx.isRouteActive(option) ? 'text-primary' : 'opacity-60 text-darkText',
									]),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "currentColor"
                          }, _hoisted_9, 2)),
                      _createVNode(_Transition, { name: "fade-quick" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(["ml-4 whitespace-pre sidebar-link-label", {
											'delay-0': _ctx.hovering,
											'text-primary font-semibold': _ctx.isRouteActive(option),
											'opacity-80': !_ctx.isRouteActive(option),
										}])
                          }, _toDisplayString(option.label), 3), [
                            [_vShow, _ctx.hovering || !_ctx.collapsed]
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ], 10, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["to", "class"])), [
                [_directive_wave, {
							color: '#6a16f0',
						}]
              ])
            }), 128))
          ], 2),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ((_ctx.hovering || !_ctx.collapsed) && _ctx.$slots.footer?.())
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "footer")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 32)
      ])
    ], 6),
    _createElementVNode("div", {
      style: {"z-index":"9999999"},
      class: _normalizeClass(["fixed flex-col justify-between block w-9/12 h-full overflow-y-auto transition-transform duration-300 ease-in-out transform md:hidden bg-light", {
			'-translate-x-full': !_ctx.showMobileSidebar,
			'translate-x-0 shadow-all-around': _ctx.showMobileSidebar,
		}]),
      id: "mobile-nav"
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Avatar, {
              user: _ctx.metaStore.user,
              size: 'lg'
            }, null, 8, ["user"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.metaStore.email), 1)
            ])
          ])
        ]),
        (_ctx.$slots.header?.())
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _renderSlot(_ctx.$slots, "header")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarOptions, (option, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: _normalizeClass(["relative my-1 overflow-hidden w-full", {
						'mt-auto mb-44': false && index == _ctx.sidebarOptions.length - 1,
					}]),
              key: 'sidebar-' + option.label,
              to: { name: option.routeName }
            }, {
              default: _withCtx(() => [
                _createElementVNode("li", {
                  id: 'sidebar-option-' + index,
                  class: _normalizeClass(["flex items-center justify-between w-full pl-5 py-2.5 rounded-r-full cursor-pointer hover:transition-colors vsm--link vsm--item", {
							'bg-primary-light bg-opacity-20 text-primary shadow-none pointer-events-none':
								_ctx.isRouteActive(option),
						}])
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-2xl material-icons-outlined", { 'text-primary': _ctx.isRouteActive(option) }])
                    }, _toDisplayString(option.icon), 3),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(option.label), 1)
                  ])
                ], 10, _hoisted_18)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]),
        (_ctx.$slots.footer?.())
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('logout'))),
            variant: 'primary',
            size: 'sm',
            outline: true,
            class: ""
          }, {
            default: _withCtx(() => [
              _hoisted_23,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("misc.logout")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showMobileSidebar)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleMobileSidebar'))),
              class: "absolute z-50 w-full h-full opacity-50 bg-dark",
              style: {}
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}